var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 654,
    height: 771,
    viewBox: "0 0 654 771",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1103.67 1208.35C1028.63 1128.24 1017.3 1111.49 973.488 1033.9C962.752 1014.89 946.748 978.608 932.761 934.6C928.568 921.43 924.91 908.438 921.675 895.681C898.638 804.398 907.137 706.901 928.557 612.422C983.221 371.362 881.752 132.849 690.738 40.8962C499.396 -51.2074 262.313 23.6691 130.873 173.641C113.772 193.156 37.4173 285.845 12.769 395.75C-65.1517 742.748 255.415 930.252 758.071 1108.32C767.851 1111.78 814.68 1126.29 824.653 1129.11L1103.7 1208.39L1103.67 1208.35Z",
    stroke: "black",
    strokeOpacity: 0.49,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape4);
export default __webpack_public_path__ + "static/media/shape4.3c4bcd0edda6e0a355e1828a7e5961a3.svg";
export { ForwardRef as ReactComponent };